<template lang="pug">
client-only
  Dialog(v-model:open="visible")
    DialogScrollContent(class="big-news-modal")
      DialogHeader
        DialogTitle {{ newsTitle }}
      .actions
        p
          a.m-2(type="primary" @click="doNotShow" v-if="!prop.hideNeverShowAgain") {{ $t('iknew') }}
          a.m-2(v-if="isAdmin" type="primary" @click="$utils.copy(klLink)") 复制链接
          NuxtLink.m-2(v-if="isAdmin" :to="editLink") 编辑
      Separator(class="my-4")
      div(class="flex justify-center items-center")
        client-only
          Tiptap(v-model="finalContent" :editable="false")
</template>

<script lang="ts" setup>
import {
  Dialog,
  DialogScrollContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Separator } from '@/components/ui/separator'

const prop = defineProps<{
  visible: any
  news: knowledgesAttributes,
  hideNeverShowAgain?: boolean,
}>()
const $utils = useUtils()

const emit = defineEmits(['update:visible'])
const i18n = useI18n()
const $t = i18n.t
// const user = useUser()
const session = useVisitorSession()
// const suspended = computed(() => user.extra.suspend)
const isAdmin = toRef(session, 'isAdmin')

const news = computed(() => {
  return prop.news
})
const { markRead } = useBigNewsRead()

const visible = computed({
  get() {
    return prop.visible
  },
  set(val) {
    emit('update:visible', val)
  }
})

const newsHTML = computed(() => {
  return processContent(i18n.locale.value === 'en' ? (news.value.html_en || news.value.html) : news.value.html)
})

const newsContent = computed(() => {
  return processContent(i18n.locale.value === 'en' ? news.value.content_en : news.value.content)
})

const finalContent = computed(() => {
  return newsHTML.value || newsContent.value
})

const newsTitle = computed(() => {
  return i18n.locale.value === 'en' ? news.value.title_en : news.value.title
})

const klLink = computed(() => {
  return `/knowledges/${news.value.id}`
})

const editLink = computed(() => {
  return `/knowledges/${news.value.id}/edit`
})

function doNotShow() {
  markRead(news.value.id)
  visible.value = false
}

function processContent(content) {
  return content?.replace(/{{siteDomain}}/g, location.host) || content
}
</script>

<style lang="postcss">

.big-news-modal {
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: var(--secondary-max-width);
  margin: 5vh auto !important;
  padding: 20px;
  background-color: var(--modal-bg) !important;
  box-shadow: var(--modal-shadow) 0px 20px 40px;
  border-radius: 2.625rem !important;
  max-height: 90vh;
  overflow-y: auto;

  @media (max-width: 768px) {
    border-radius: 0;
  }

  @media (max-width: 768px) {
    width: 100% !important;
    margin-top: 0vh !important;
  }

  .actions {
    text-align: center;
  }
}
</style>
